import { Link } from 'react-router-dom'
import { usePageTitle } from '@/hooks/usePageTitle'

/**
 * No equivalent existed: ASP.NET returned a bare 404 for an unmatched route.
 * A SPA needs something to render, and a dead end with no way back is worse
 * than the framework default.
 */
export function NotFoundPage(): JSX.Element {
  usePageTitle('Page not found')

  return (
    <div className="container py-5 text-center">
      <h1 className="text-primary">404</h1>
      <h4 className="mb-3">Page not found</h4>
      <p className="text-muted mb-4">The page you are looking for does not exist or has moved.</p>
      <Link to="/" className="btn btn-primary">
        Back to home
      </Link>
    </div>
  )
}
